/*
 * TranscriptsFilter Messages
 *
 * This contains all the text for the TranscriptsFilter component.
 */
import { defineMessages } from 'react-intl';

const messages = {
  tableHeaderId: {
    id: 'DASHBOARD.tableHeaderId',
    defaultMessage: 'ID',
  },
  organizationName: {
    id: 'DASHBOARD.organizationName',
    defaultMessage: 'Client',
  },
  company: {
    id: 'DASHBOARD.company',
    defaultMessage: 'Company',
  },
  country: {
    id: 'DASHBOARD.country',
    defaultMessage: 'Country',
  },
  connectionStatus: {
    id: 'DASHBOARD.connectionStatus',
    defaultMessage: 'Connection status',
  },
};

export default defineMessages(messages);



// WEBPACK FOOTER //
// ./components/organisms/OrganizationsTable/messages.js